<template>

  <!-- container start -->
  <div class="container">

    <!-- header start -->
    <header>
      <h1><a href="../"><img src="../assets/site_logo.png" alt="みちのく震録伝" /></a></h1>
      <h2>みちのく震録伝<span class="site-name">自然災害アーカイブβ2.0</span><br>
        <span class="site-copy">東日本大震災に関するあらゆる記憶、記録、事例、知見を収集し、国内外や未来に共有します</span></h2>
      <div class="head-r">
        <div class="det-btn-box">
          <a @click="$router.go(-1)" class="btn-back"><img src="../assets/arw_l.png" alt=""><span>戻る</span></a>
        </div>
      </div>
    </header>
    <!-- header end -->

    <!-- nav start -->
    <nav>
    </nav>
    <!-- nav end -->

    <!-- wrapper start -->
    <div class="wrapper">
      <!-- contents start -->
      <div class="contents">
        <!-- article start -->
        <article class="det-article">
          <h4 class="title-det">{{ item.title }}</h4>
          <div class="det-box">
            <div class="det-info-tbox">
              <div class="det-info-tlbox">
                <div class="det-img-box">
                  <div v-if='media != "MOVIE"' id='imgbox' />
                  <video  v-else controls>
                    <source v-bind:src="item.mp4" type='video/mp4'/>
                    <source v-bind:src="item.ogg" type='video/ogg'/>
                    <p>動画を再生するには、videoタグをサポートしたブラウザが必要です。</p>
                  </video>
                </div>
                <!-- 
                     <div class="btn-ex-box"><a href="#" target="_blank"><img src="../assets/amp.png" alt="" /> 拡大する</a></div>
                -->
              </div>
              <div class="det-info-trbox">
                <div class="det-map-box">
                  <!-- keyの追加は back対応 https://github.com/vuejs/vue-router/issues/1917 -->
                  <div id='mapbox' /></div>

                  


              </div>
            </div>
            
            <div class="det-info-bbox">
              <div class="det-info-btbox">
                <div class="det-info-btlbox">
                  <dl>
                    <dt>作成日(撮影日)</dt>
                    <dd>{{ item.created | dateFormatter}}</dd>
                  </dl>
                  <dl>
                    <dt>撮影場所</dt>
                    <dd>{{ item.spatial }}&nbsp;</dd>
                  </dl>
                </div>
                <div class="det-info-btrbox">
                  <dl>
                    <dt>撮影者</dt>
                    <dd><span v-for="c in item.creator" v-bind:key="c">{{ c }}</span>&nbsp;</dd>
                  </dl>
                  <dl>
                    <dt>提出日</dt>
                    <dd>{{item.dateSubmitted | dateFormatter}}</dd>
                  </dl>
                </div>
              </div>
              
              <dl>
                <dt>説明</dt>
                <dd>{{ item.description }}&nbsp;</dd>
              </dl>
              <dl>
                <dt>分類(タグ) </dt>
                <dd>
                  <span v-for="c in item.subject"  v-bind:key="c">

                    <router-link v-bind:to="{ path: '/result', query: { freeword: c}}">{{ c }}</router-link>
                  </span>
                </dd>
              </dl>
              <dl class="di-inqno">
                <dt>お問い合わせ番号</dt>
                <dd>{{ item.identifier }}</dd>
              </dl>
              <dl v-if='(media === "DOCUMENT" || media === "IMAGE") && item.enclosure '>
                <dt>ダウンロード</dt>
                <dd><a download v-bind:href="item.enclosure.url">{{item.enclosure.url}}</a></dd>
              </dl>

            </div>
          </div>
        </article>
        <!-- article end -->

        <div class="det-btn-box center-block">
          <a @click="$router.go(-1)" class="btn-back"><img src="../assets/arw_l.png" alt=""><span>戻る</span></a>
        </div>


      </div>
      <!-- contents end -->

    </div>
    <!-- wrapper end -->
  </div>
  <!-- container end -->


</template>
<script>
 //ol 生モジュール
 //olモジュールの読み込み
 import 'ol/ol.css'
 import {transform} from 'ol/proj'
 import Feature from 'ol/Feature';
 import Map from 'ol/Map'
 import View from 'ol/View'
 import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer'
 import IIIF from 'ol/source/IIIF'
 import XYZ from 'ol/source/XYZ'
 import Attribution from 'ol/control/Attribution'
 import IIIFInfo from 'ol/format/IIIFInfo'
 import VectorSource from 'ol/source/Vector'
 import {Icon, Style} from 'ol/style'
 import Point from 'ol/geom/Point';
 
 import { RepositoryFactory } from '../repositories/RepositoryFactory'
 const ItemsRepository = RepositoryFactory.get('items')
 const IIIFRepository = RepositoryFactory.get('iiif')


 export default {
     name: 'mapview',
     computed: {
         item: function(){
             if(!this.data.channel) return {};
             return this.data.channel.item[0];
         },
         media: function(){
             if(!this.data.channel) return {};
             return this.data.channel.item[0].categories[0].content
         }
     },
     data: function(){
         return {
             data: {},
             imageInfo:{},
             imgview: null
         }
     },

     mounted(){
         this.fetch()
		 
     },
     updated(){
         this.createMap()
     },
     methods: {
         async fetch(){
             const { data } = await ItemsRepository.getOne(this.$route.params.uuid)

             this.data = data
             this.$store.dispatch('addRecent', this.item)
			 this.createImg()

         },
		 async createImg () {
		              var layer  = new TileLayer();

             this.imgview = new Map ({
                 target: 'imgbox',
                 layers: [
                     layer
                 ],
             })
             try{
                 var imageInfo = await IIIFRepository.getInfo(this.$route.params.uuid)
                 this.imageInfo = imageInfo.data;
                 console.log('imageInfo:' + this.imageInfo)
                 var options = new IIIFInfo(this.imageInfo).getTileSourceOptions();
                 if (options === undefined || options.version === undefined) {
                     return;
                 }
                 options.zDirection = -1;
                 var iiifTileSource = new IIIF(options);

                 layer.setSource(iiifTileSource);
                 this.imgview.setView(new View({
                     resolutions: iiifTileSource.getTileGrid().getResolutions(),
                     extent: iiifTileSource.getTileGrid().getExtent(),
                     constrainOnlyCenter: true
                 }))
                 this.imgview.getView().fit(iiifTileSource.getTileGrid().getExtent());
             }catch(error){}

		 },
         async createMap () {
             
             const lat = this.item.lat
             const lon = this.item.lon

             if(!lat && !lon) return;

             

             var pointLayer = new VectorLayer({
                 source: new VectorSource({
                     features: [new Feature({
                         geometry: new Point(transform([lon, lat], "EPSG:4326", "EPSG:3857")),
                     })]}),
                 
                 style: new Style({
                     image: new Icon({
                         anchorXUnits: 'fraction',
                         anchorYUnits: 'pixels',
                         src: '../_img/pin.png'
                     })})
             })


             this.mapview = new Map({
                 target: "mapbox",
                 layers: [
                     new TileLayer({
                         source: new XYZ({
                             attributions: [
                                 new Attribution({
                                     html: "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>",
                                     collapsible: false

                                 })
                             ],
                             url: "https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png",
                             projection: "EPSG:3857"
                         })
                     }),
                     pointLayer
                 ],
                 view: new View({
                     projection: "EPSG:3857",
                     center: transform([lon, lat], "EPSG:4326", "EPSG:3857"),
                     zoom: 16
                 })
             }
             )


         }
     }
 }

</script>
<style scoped>

 #imgbox {
     width: 100%;
     height: 440px;
 }
 #mapbox {
     width: 100%;
     height: 440px;
 }


 
 /*---------------------------------
    detail
    ----------------------------------*/

 nav {
     height: 25px !important;
 }

 .det-article { 
     margin: 0 auto 20px auto;
     padding: 20px 40px;
     width: 100%;
     border: 1px solid #332C59;
     /*box-shadow: 0 1px 1px 2px rgba(0,0,0,0.05);*/
     box-sizing: border-box;
 }

 .title-det{
     color: #332C59;
     font-size: 130%;
     border-bottom: 3px solid #332C59;
     margin-bottom: 30px;
     padding-left: 1em;
     padding-bottom: 5px;
     background: url(../assets/lh_c.png) no-repeat left 10px;
 }

 .det-btn-box a {
     width: 130px;
     height: 40px;
     display: block;
     float: left;
     padding: 0;
     text-align: center;
     line-height: 40px;
     background-color: #332C59;
     font-size: 110%;
     color: #fff;
     box-sizing: border-box;
     letter-spacing: 0.1em;
 }

 .det-btn-box a img{
     margin-right: 5px;
 }

 .center-block {
     overflow: hidden;
 }

 .center-block a {
     margin: 0 auto;
     float: none;
 }

 .det-box{
     margin: 20px 0;
     width: 100%;
 }

 .det-info-tbox {
     position: relative;
     width: 100%;
     overflow: hidden;
 }

 .det-info-tlbox {
     float: left;
     width: 49%;
     height: 100%;
 }

 .det-img-box {
     width: 100%;
     height: auto;
     max-height: 440px;
     overflow: hidden;
     background: url(../assets/side_bg.png) repeat left top;
 }

 .det-img-box img { 
     width: 100%;
     height: auto;
 }

 .btn-ex-box {
     text-align: right;
     font-size: 85%;
     margin-top: 5px;
 }

 .det-info-trbox { 
     margin-left: 51%;
 }

 .det-map-box { 
     width: 100%;
 }

 .memo-box {
     clear: both;
     border-bottom: 1px dotted #332C59;
     padding: 15px 0;
 }

 .det-info-bbox {
     margin: 30px 3%;
     padding: 0;
     border-top: 1px solid #332C59;
 }


 .det-info-btbox {
     overflow: hidden;
 }

 .det-info-bbox a {
     margin-right: 1em;
     display: inline-block;
 }

 .det-info-btlbox,
 .det-info-btrbox {
     float: left;
     width: 49%;
 }

 .det-info-btrbox {
     margin-left: 2%;
 }
 .det-info-btlbox dl,
 .det-info-btrbox dl,
 .det-info-bbox dl{
     border-bottom: 1px dotted #332C59;
     padding: 15px 0;
 }
 .det-info-btlbox dl dt,
 .det-info-btrbox dl dt,
 .det-info-bbox dl dt{
     float: left;
     width: 9em;
     font-weight: bold;
 }

 .det-info-btlbox dl dd,
 .det-info-btrbox dl dd,
 .det-info-bbox dl dd {
     margin-left: 9em;
 }

 .det-map-api {
     display: none;
 }


 
 /*@media screen and (max-width:1610px) {

    .top-n-info {
    min-height: 150px;
    }

    }*/

 @media screen and (max-width:1460px) {

 }


 /* 1120px (Small Desktop, Netbook) */
 @media screen and (max-width:1350px) {
     header {
         width: 90% ;
     }

     .search-box {
         width: 90% ;
     }

     .contents {
         width: 90% ;
     }


 }
 @media screen and (max-width:850px) {

 }


 @media screen and (max-width:770px) {

     header {
         width: 94%;
     }

     a:hover,
     footer a:hover {
         opacity: 1;
     }

     .btn-acc:hover,
     .accordion_head:hover {
         opacity: 1;
     }

     p.submit a:hover {
         opacity: 1;
     }

     span a.btn-map-s:hover {
         opacity: 1;
     }



     .det-article { 
         margin: 0 auto 20px auto;
         padding: 0;
         width: 100%;
         border: none;
     }

     .title-det{
         font-size: 120%;
         border-bottom: 1px solid #332C59;
         margin-bottom: 15px;
         padding-left: 1em;
         padding-bottom: 3px;
         background: url(../assets/lh_c.png) no-repeat left 8px;
     }


     .det-box{
         margin: 15px 0;
         width: 100%;
     }

     .det-info-tlbox {
         float: none;
         width: 100%;
     }

     .det-img-box {
         width: 100%;
         height: auto;
     }

     .btn-ex-box {
         font-size: 90%;
         margin-bottom: 10px;
     }

     .det-info-trbox { 
         margin-left: 0;
     }

     .det-map-box iframe{
         height: 280px;
     }

     #imgbox {
         height: 280px;
     }
     #mapbox {
         height: 280px;
     }



     .det-info-bbox {
         margin: 20px 0;
         padding: 0;
         border-top: 1px solid #332C59;
     }

     .det-map-api {
         display: block;
         padding-right: 20px;
     }
     .det-map-link,
     .det-map-api {
         font-size: 90%;
         overflow: hidden;
     }

     .det-map-link img,
     .det-map-api img {
         margin-top: -2px;
     }

     /*
        .det-info-btbox {
        overflow: hidden;
        }

        .det-info-bbox a {
        margin-right: 1em;
        display: inline-block;
        }*/

     .det-info-btlbox,
     .det-info-btrbox {
         float: none;
         width: 100%;
     }

     .det-info-btrbox {
         margin-left: 0;
     }
     .det-info-btlbox dl,
     .det-info-btrbox dl,
     .det-info-bbox dl{
         border-bottom: 1px dotted #332C59;
         padding: 10px 0;
     }
     .det-info-btlbox dl dt,
     .det-info-btrbox dl dt,
     .det-info-bbox dl dt{
         float: left;
         width: 8em;
         font-weight: bold;
     }

     .det-info-btlbox dl dd,
     .det-info-btrbox dl dd,
     .det-info-bbox dl dd {
         margin-left: 8em;
     }

     .det-info-bbox dl.di-inqno dt,
     .det-info-bbox dl.di-inqno dd {
         display: block;
         float: none;
         width: 100%;
         margin-left: 0;
     }


 }


 /*  */
 @media screen and (max-width:740px) {

     /*common*/

     header {
         height: 60px;
     }

     header h1 {
         margin-top: 3px;
         padding: 0;
         height: 45px;
         width: auto;
         line-height: 1;
     }

     header h1 a img{
         height: 45px;
         width: auto;
     }

     header h2 {
         margin: 6px 0 0 5px;
         padding: 0;
         font-size: 102%;
     }

     header h2 .site-name{
         margin-top: 2px;
         margin-left: 0;
         display: block;
     }

     header h2 .site-copy{
         display: none;
     }

     .contents {
         padding-top: 12px;
     } 

     /*det*/

     .head-r {
         margin-top: 5px;
         margin-right: 2%;
     }

     .head-r .det-btn-box {
         
     }

     .det-btn-box a {
         text-align: center;
         margin-left: 0;
         width:40px
     }

     .det-btn-box a span{
         display: none;
     }

     .det-btn-box a img{
         margin-right: -5px;
         margin-top: -4px;
     }

 }

</style>
